/**
 * Micro-markup per campi testo in admin: **grassetto**, *corsivo*, a capo
 * (invio nella textarea). Sempre a partire da testo escapato (mai HTML
 * grezzo dall'admin) — le uniche tag prodotte sono quelle generate qui
 * sotto, mai passthrough di markup scritto a mano nel campo.
 */
function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** Converte il micro-markup in HTML sicuro da passare a dangerouslySetInnerHTML. */
export function renderTextMarkup(text) {
  return escapeHtml(text || '')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br />');
}
